import { create } from 'zustand';

interface ImpersonateState {
  impersonatedUserId: string | null;
  impersonatedUserName: string | null;
  startImpersonation: (userId: string, userName: string | null) => void;
  stopImpersonation: () => void;
  isImpersonating: boolean;
}

export const useImpersonateStore = create<ImpersonateState>((set) => ({
  impersonatedUserId: null,
  impersonatedUserName: null,
  isImpersonating: false,
  startImpersonation: (userId, userName) =>
    set({ impersonatedUserId: userId, impersonatedUserName: userName || 'Usuário', isImpersonating: true }),
  stopImpersonation: () =>
    set({ impersonatedUserId: null, impersonatedUserName: null, isImpersonating: false }),
}));
